import React from 'react';

const MyProfileCrumb = () => <p>My Profile</p>;

export default MyProfileCrumb;
